<script lang="ts">
  let { size = 16 }: { size?: number } = $props();
</script>

<svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M13.5 1.75C13.5 1.33579 13.8358 0.999999 14.25 0.999999C14.6642 0.999999 15 1.33579 15 1.75L15 14.25C15 14.6642 14.6642 15 14.25 15C13.8358 15 13.5 14.6642 13.5 14.25L13.5 1.75ZM1 8C1 7.58579 1.33579 7.25 1.75 7.25L9.43945 7.25L6.71973 4.53027C6.42683 4.23738 6.42683 3.76262 6.71973 3.46973C7.01262 3.17683 7.48738 3.17683 7.78027 3.46973L11.7803 7.46973C12.0732 7.76262 12.0732 8.23738 11.7803 8.53027L7.78027 12.5303C7.48738 12.8232 7.01262 12.8232 6.71973 12.5303C6.42683 12.2374 6.42683 11.7626 6.71973 11.4697L9.43945 8.75L1.75 8.75C1.33579 8.75 1 8.41421 1 8Z"
    fill="currentColor"
  />
</svg>
